<template>
  <TabsContainer :tab="tab" :jid="jid" :loading="loading">
    <template #default="{ activeTab, jobId }">
      <el-tab-pane key="full" label="Full statistic" name="full">
        <TabFull
          v-if="activeTab === 'full'"
          v-model="loading"
          :jid="jobId.full"
        />
      </el-tab-pane>
      <el-tab-pane
        v-if="!isRtbUser"
        key="traffic"
        label="Traffic Report"
        name="traffic"
      >
        <TabDaily
          v-if="activeTab === 'traffic'"
          v-model="loading"
          :jid="jobId.traffic"
        />
      </el-tab-pane>
      <el-tab-pane key="realtime" label="Realtime activity" name="realtime">
        <TabRealtime
          v-if="activeTab === 'realtime'"
          v-model="loading"
          :jid="jobId.realtime"
        />
      </el-tab-pane>
    </template>
  </TabsContainer>
</template>

<script lang="ts">
import { computed, ref, defineComponent } from 'vue'
import TabsContainer from '@/components/Reports/TabsContainer.vue'

import TabFull from './components/TabFull.vue'
import TabRealtime from './components/TabRealtime.vue'
import TabDaily from './components/TabDaily.vue'

import { useCampaignsStore } from '@/apps/traforama/store/campaigns'
import { useCreativesStore } from '@/apps/traforama/store/creatives'
import { useCountriesStore } from '@/store/modules/countries'
import { useSpotsStore } from '@/apps/traforama/store/spots'
import { useFeedsStore } from '@/store/modules/feeds'
import { useUserStore } from '@/store/modules/user'

import { ICampaignsPayload, ICampaignsFilter } from '@/api/campaigns'
import { IFeedsPayload } from '@/api/feeds'
import { ICreativesPayload } from '@/api/creatives'
import { ISpotsPayload } from '@/api/spots'

import useRouter from '@/hooks/useRouter'

export default defineComponent({
  name: 'Reports',
  components: {
    TabsContainer,
    TabFull,
    TabRealtime,
    TabDaily
  },
  props: {
    jid: {
      type: String,
      default: null
    },
    tab: {
      type: String,
      default: null
    }
  },
  setup(props, context) {
    const feedsStore = useFeedsStore()
    const campaignsStore = useCampaignsStore()
    const creativesStore = useCreativesStore()
    const countriesStore = useCountriesStore()
    const spotsStore = useSpotsStore()
    const userStore = useUserStore()

    const { isRtbUser } = userStore
    const loading = ref(true)
    const defaultFilters = {
      disabled: false,
      state: ['approved', 'paused'],
      include_recent: true
    }
    const filter = ref<ICampaignsFilter>({ ...defaultFilters })

    Promise.all([
      userStore.GetUserInfo(false),
      campaignsStore.FetchItems({
        filter: filter.value,
        limit: 100500,
        start: 0
      } as ICampaignsPayload),
      spotsStore.FetchItems({ limit: 100, start: 0 } as ISpotsPayload),
      feedsStore.FetchItems({
        limit: 100,
        start: 0,
        filter: {}
      } as IFeedsPayload),
      creativesStore.FetchItems({
        filter: { disabled: false, advert_state: [20, 30] },
        limit: 100500,
        start: 0
      } as ICreativesPayload),
      countriesStore.GetItems()
    ]).then((values) => {
      loading.value = false
    })

    return {
      loading,
      isRtbUser
    }
  }
})
</script>
